import * as ActionTypes from './actionTypes.js';
import _ from 'lodash';
export default function userSimulationReducer(state = {}, action) {
  switch (action.type) {
    case ActionTypes.USER_SIMULATION_DATA:
      return _.extend({}, state, { simulationUsersList: action.payload });
    default:
      return state;
  }
}
